// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Mcsfq","question":"styles_question__3F-5m","description":"styles_description__3kYHB"};